import {Button as BaseButton} from '@base-ui/react/button';
import React from 'react';

interface ButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
    link?: string;
    variant?: 'primary' | 'dark' | 'light' | 'disabled';
    id?: string;
    /** Render the button as a different HTML element, e.g. component="label" for file upload triggers */
    component?: keyof React.JSX.IntrinsicElements;
    version?: string;
}

export default function Button({children, className, onClick, disabled, link, variant, id, component}: ButtonProps) {
    const cls = `baseButton ${className ?? ''} ${variant ?? ''}`;

    /**
     * Determine the underlying element:
     * - `link` → render as <a href>
     * - `component` (e.g. "label") → render as that element (used for file upload label trick)
     * - default → plain <button>
     */
    const renderEl = link
        ? <a href={link} />
        : component
            ? React.createElement(component)
            : <button />;

    return (
        <BaseButton
            render={renderEl}
            className={cls}
            disabled={disabled}
            onClick={onClick}
            id={id}
        >
            {children}
        </BaseButton>
    );
}
